module.exports = __webpack_public_path__ + "assets/media/arrow.667c01ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/ExtensionPreview/arrow.svg
// module id = 2050
// module chunks = 0